module.exports = __webpack_public_path__ + "static/media/young-male-thumb.e0575fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Reconstructions/2D/young-male-thumb.jpg
// module id = 476
// module chunks = 0